






import { Component, Prop, Watch } from 'vue-property-decorator'
import PointList from './components/PointList.vue';
import AnalyticsMixin from "../../mixins/AnalyticsMixin";
import PocketBlock from "../../share/common/pocket/Pocket.vue"

@Component({
    name: 'Points',
    components: { PointList, PocketBlock }
})
export default class Points extends AnalyticsMixin {
    @Prop({ default: false}) showList: boolean;

    @Watch('showList')
    async toggleList(value: boolean) {

        if (value) {
            this.sendScreenView('Rating');
        }
        else {
            this.$enableBodyScroll(document.querySelector('.point-list') as HTMLElement);
            this.sendScreenView(this.$store.state.screenNameData?.prevName || this.$route.meta?.analyticName);
        }
    }

    get routeHash() {
        return this.$route.hash;
    }

    close() {
        this.$emit('close');
    }
}
